export const LeviBlackCardTooltipText = {
  fi: 'Levi Black -pisteitä',
  en: 'Levi Black Points',
} as const;
